import { TripBookingGuidelineInput } from '../../lib/types/models/trip-booking/trip-booking-guideline-input'
import { TripBookingGuideline } from '../../lib/types/models/trip-booking/trip-booking-guildeline'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createTripBookingGuideline(data: TripBookingGuidelineInput) {
  return restApiClient
    .url(constructApiUrl(API.tripBookingGuidelines.create.url, null))
    .post<TripBookingGuideline, TripBookingGuidelineInput>(data)
}
